<template>
	<surveys-list class="pb-5" :tool-code="toolCode" />
</template>

<script>
import surveysList from '@/components/surveys/surveys-list';
import toolsCodes from '@/shared/tools-codes';

const { OrgaCultureInventory } = toolsCodes;

function data() {
	return {
		toolCode: OrgaCultureInventory,
	};
}

export default {
	name: 'surveys',
	components: {
		surveysList,
	},
	data,
};
</script>



// WEBPACK FOOTER //
// src/pages/inventory/page-surveys-inventory.vue